import { ChevronDown } from 'lucide-react';
import { usePrefsStore } from '@/stores/prefs.js';
import { SUPPORTED_LOCALES } from '@/lib/i18n/index.js';
import { Icon } from '@/components/ui/icon.js';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu.js';

const LOCALE_LABELS: Record<string, string> = {
  en: 'English',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  zh: '中文',
  km: 'ខ្មែរ',
  lo: 'ລາວ',
  my: 'မြန်မာ',
};

export function AuthLangSwitcher() {
  const locale = usePrefsStore((s) => s.locale);
  const setLocale = usePrefsStore((s) => s.setLocale);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1.5 h-9 px-3 rounded-full border border-[var(--border)] bg-[var(--bg-raised)]/70 hover:bg-[var(--bg-elevated)] text-[13px] font-semibold text-[var(--text-primary)] transition-colors"
        >
          <span>{LOCALE_LABELS[locale] ?? locale.toUpperCase()}</span>
          <ChevronDown size={14} className="text-[var(--text-muted)]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {SUPPORTED_LOCALES.map((l) => {
          const active = l === locale;
          return (
            <DropdownMenuItem
              key={l}
              onSelect={() => setLocale(l)}
              className={`flex items-center justify-between text-[13px] ${
                active ? 'font-bold text-[var(--primary)]' : 'text-[var(--text-primary)]'
              }`}
            >
              <span>{LOCALE_LABELS[l] ?? l}</span>
              {active && <Icon name="check" size={14} />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
